var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToken1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(-202 -223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    transform: "translate(202 223)",
    fill: "none",
    stroke: "#758698",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 8.5,
    height: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(-0.5 9.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1544.954,215.133v5.056",
    transform: "translate(-1340)",
    fill: "none",
    stroke: "#758698",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    transform: "translate(204 216.7)",
    fill: "#fff",
    stroke: "#758698",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-2",
    "data-name": "Path 46",
    d: "M1544.954,215.133v5.056",
    transform: "translate(-1340)",
    fill: "none",
    stroke: "#758698",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_25-2",
    "data-name": "Ellipse 25",
    transform: "translate(204 215.7)",
    fill: "#fff",
    stroke: "#758698",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-3",
    "data-name": "Path 46",
    d: "M1544.954,215.133v5.056",
    transform: "translate(-1340)",
    fill: "none",
    stroke: "#758698",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_25-3",
    "data-name": "Ellipse 25",
    transform: "translate(204 218.2)",
    fill: "#fff",
    stroke: "#758698",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.75,
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken1);
export default __webpack_public_path__ + "static/media/token1.6ab2dbf2f12fd02922e876cc6b5c65cf.svg";
export { ForwardRef as ReactComponent };